import script from "./AppBannerWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBannerWrapper.vue?vue&type=script&setup=true&lang=js"

import "./AppBannerWrapper.vue?vue&type=style&index=0&id=63293b52&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63293b52"]])

export default __exports__